module.exports = __webpack_public_path__ + "img/pen-input.b948efa8.svg";